import { render, staticRenderFns } from "./haokaHome.vue?vue&type=template&id=ccfdd8ce&scoped=true&"
import script from "./haokaHome.vue?vue&type=script&lang=js&"
export * from "./haokaHome.vue?vue&type=script&lang=js&"
import style0 from "./haokaHome.vue?vue&type=style&index=0&id=ccfdd8ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfdd8ce",
  null
  
)

export default component.exports